import classNames from 'classnames';
import { isString } from 'lodash';
import type { FC, ReactNode } from 'react';
import React from 'react';

interface IReviewItemProps {
  label: string;
  value?: ReactNode;
  full?: boolean;
  // Leere Werte werden standardmäßig ausgeblendet. Mit showEmpty wird
  // stattdessen ein Platzhalter angezeigt.
  showEmpty?: boolean;
}

const isEmptyValue = (value: ReactNode): boolean =>
  value === undefined
  || value === null
  || value === false
  || (isString(value) && value.trim() === '');

const ReviewItem: FC<IReviewItemProps> = ({
  label,
  value,
  full = false,
  showEmpty = false
}) => {
  const empty = isEmptyValue(value);

  if (empty && !showEmpty) {
    return null;
  }

  return (
    <div className={classNames('review-item', {
      'review-item-full': full
    })}>
      <div className="review-item-body">
        <span className="review-item-label">{label}</span>
        <div className="review-item-value">
          {empty ? '—' : value}
        </div>
      </div>
    </div>
  );
};

export default ReviewItem;
